import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import {useEthers} from "@usedapp/core";
import WalletConnectProvider from "@walletconnect/web3-provider";
import {styled} from "@mui/system";

function ConnectWalletModal({walletModal, setWalletModal}) {
  const {activateBrowserWallet, activate} = useEthers();
  async function onConnectWallet() {
    try {
      const provider = new WalletConnectProvider({
        rpc: {
          56: "https://bsc-dataseed1.binance.org/",
          97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
          43113: "https://api.avax-test.network/ext/bc/C/rpc",
        },
        chainId: 56,
        bridge: "https://bridge.walletconnect.org",
      });
      await provider.enable();
      await activate(provider);
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <Dialog onClose={() => setWalletModal(!walletModal)} open={walletModal}>
      <DialogTitle sx={{textAlign: "center", p: 3}}>
        <Typography variant="h3">Choose Wallet</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack sx={{p: 3}} spacing={3}>
          <Grid
            sx={{cursor: "pointer"}}
            justifyContent="space-between"
            alignItems="center"
            container
            onClick={activateBrowserWallet}
          >
            <Grid sx={{pr: 3}} item xs={4}>
              <img
                alt="Metamask"
                src={require(`../../assets/logos/metamask.svg`).default}
                height="32"
              />
            </Grid>
            <Grid item xs={8}>
              <Typography>Metamask</Typography>
            </Grid>
          </Grid>

          <Grid
            sx={{cursor: "pointer"}}
            justifyContent="space-between"
            alignItems="center"
            container
            onClick={onConnectWallet}
          >
            <Grid sx={{pr: 3}} item xs={4}>
              <img
                alt="WalletLink"
                src={require(`../../assets/logos/walletconnect.svg`).default}
                height="32"
              />
            </Grid>
            <Grid item xs={8}>
              <Typography>Wallet Connect</Typography>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default ConnectWalletModal;

const BatuGrid = styled(Grid)``;

const AhmetStack = styled(Stack)``;
